export default __webpack_public_path__ + "static/media/seventh-strip.9a808106.png";